export const appReference = 1;